// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608201926/js/" + chunkId + "." + {"44":"d0ce19d5","225":"a58ae89b","481":"3aee2fee","486":"17523ca1","770":"7cf92036"}[chunkId] + ".0.783360860441112.chunk.js";
};